export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11538.e75ac4ce.jpg";